import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'AVGPRICE',
  version: 1,
  label: 'Average Price (OHLC/4)',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 90,
  inputs: [],
  outputs: [line('avgprice', 'OHLC/4', COLOR.blue)],
  talib: { functions: ['AVGPRICE'], expr: 'AVGPRICE(open, high, low, close)' },
  listed: true,
  tailSafe: true,
  lookback: () => 0,
}
export default def
